import React from 'react';
import tinycolor from 'tinycolor2';

const SafariGiraffe = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;
  const dark = tinycolor(base).darken(30).toString();

  return (
    
    <svg width={`${radius * 2}px`} height={`${radius * 2.35}px`} x={`-${radius}px`} y={`-${radius * 0.52}px`} viewBox="0 0 200 235" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Artboard-4">
            <g id="Group-2">
              <g id="Group" transform="translate(79.000000, 26.000000)" fill="#555">
                <circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle>
                <circle id="Oval-Copy" cx="34.5" cy="7.5" r="7.5"></circle>
              </g>
              <path d="M54,135 L104,135 L104,185 C76.3857625,185 54,162.614237 54,135 Z" id="Oval-2-Copy-6" fill={dark}></path>
              <path d="M154,185 C154,212.614237 131.614237,235 104,235 L104,185 L154,185 Z" id="Oval-2-Copy-10" fill={dark}></path>
              <path d="M54,235 C54,207.385763 76.3857625,185 104,185 L104,235 L54,235 Z" id="Oval-2-Copy-11" fill={base}></path>
              <path d="M154,185 L104,185 L104,135 C131.614237,135 154,157.385763 154,185 Z" id="Oval-2-Copy-6" fill={base}></path>
              <path d="M157,25 L132,25 L132,1.13686838e-13 C145.807119,1.17239551e-13 157,11.1928813 157,25 Z" id="Oval-2-Copy-13" fill={base}></path>
              <path d="M42,25 C42,11.1928813 53.1928813,1.17239551e-13 67,1.13686838e-13 L67,25 L42,25 Z" id="Oval-2-Copy-14" fill={base}></path>
              <path d="M200,52 C200,107.228475 155.228475,152 100,152 C44.771525,152 0,107.228475 0,52 L200,52 Z" id="Oval-3" fill={base}></path>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default SafariGiraffe;

export function resize(props) {
  const {radius, minY, maxY} = props;

  return {
    ...props,
    minY: minY + radius * .52,
    maxY: maxY + radius * .83,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/safari/giraffe.js